/** biome-ignore-all lint/correctness/useExhaustiveDependencies: <explanation> */
import { useEffect, useState } from 'react'
import { useWatch } from 'react-hook-form'
import { Button } from '@/components/ui/button'
import { cn } from '@/lib/utils'
import { matchCourseSchema } from '@/schemas/education/match-courses-schema'
import type { StudentRequestedCoursesFormMethods } from '@/types/forms/student-requested-courses-form-methods'

interface ButtonFooterProps {
  formMethods: StudentRequestedCoursesFormMethods
  grantAction?: (validform?: boolean) => void
  denyAction?: () => void
  className?: string
  disableButons?: boolean
}

export function ButtonFooter({
  formMethods,
  denyAction,
  grantAction,
  className,
  disableButons
}: ButtonFooterProps) {
  const [validForm, setValidForm] = useState(false)

  const watched = useWatch({
    control: formMethods?.control
  })

  const handleValidForm = async () => {
    const validateFields = matchCourseSchema.pick({
      courseEquivalences: true,
      serie: true
    })

    const values = formMethods.getValues?.()
    const isValid = validateFields.safeParse(values).success
    setValidForm(isValid)
  }

  useEffect(() => {
    handleValidForm()
  }, [watched])

  return (
    <div className={cn('flex gap-5 w-fit', className)}>
      <Button
        disabled={disableButons}
        onClick={denyAction}
        className="bg-background border border-destructive text-destructive"
      >
        Indeferir
      </Button>
      <Button
        disabled={disableButons}
        onClick={() => grantAction?.(validForm)}
        className={cn(
          'bg-background border border-[var(--brand-green)] text-[var(--brand-green)]',
          { 'opacity-50': !validForm }
        )}
      >
        Deferir
      </Button>
    </div>
  )
}
